module.exports = __webpack_public_path__ + "static/img/ewm-02.f9349ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/ewm-02.jpg
// module id = 9/oO
// module chunks = 1